import {
    HOME_DIAGNOSTIC_FILTER_LIST,
    HOME_DIAGNOSTIC_ID,
    HOME_DISPLAY_DIAGNOSTICS,
    HOME_DISPLAY_TILES,
    HOME_ORBIT_LIST,
    HOME_DIAGNOSTIC_LIST,
    HOME_DEFAULT_ORBIT,
    HOME,
    INITIAL_TOP_NAV_DISPLAY,
    NAVIGATE_TO_HOME_PAGE,
    TERMS_CONDITIONS_COMPLETED,
    REFRESH_TILE_ATTRIBUTE_LIST,
    HOME_SERVICE_LINE_LIST,
    HOME_SERVICE_LINE_ID,
    HOME_DISPLAY_SERVICE_LINE,
    HOME_ORGANIZATION_ID,
    HOME_ORGANIZATION_LIST,
    HOME_DISPLAY_ORGANIZATION,
    HOME_DISPLAY_ORBIT, SET_HIDE_TOP_NAV, SELECT_ORBIT_HOME, SET_WELCOME_MESSAGE, SET_VIEWED_WELCOME_MESSAGE
} from "./types.js";

export const setInitialTopNavDisplay = (value) => ({
    type: INITIAL_TOP_NAV_DISPLAY,
    payload: {
        initialTopNavDisplay: value
    }
})

export const setDefaultOrbit = (value) => ({
    type: HOME_DEFAULT_ORBIT,
    payload: {
        defaultOrbit: value
    }
})

export const setOrganizationId = (value) => ({
    type: HOME_ORGANIZATION_ID,
    payload: {
        organizationId: value
    }
})

export const setServiceLineList = (value) => ({
    type: HOME_SERVICE_LINE_LIST,
    payload: {
        serviceLineList: value
    }
})

export const setOrganizationList = (value) => ({
    type: HOME_ORGANIZATION_LIST,
    payload: {
        organizationList: value
    }
})

export const setServiceLineId = (value) => ({
    type: HOME_SERVICE_LINE_ID,
    payload: {
        serviceLineId: value
    }
})

export const setHideTopNav = (value) => ({
    type: SET_HIDE_TOP_NAV,
    payload: {
        hideTopNav: value
    }
})

export const setDisplayTiles = (value) => ({
    type: HOME_DISPLAY_TILES,
    payload: {
        displayTiles: value
    }
})

export const setSelectOrbit = (value) => ({
    type: SELECT_ORBIT_HOME,
    payload: {
        orbitHome: value
    }
})

export const setDisplayServiceLine = (value) => ({
    type: HOME_DISPLAY_SERVICE_LINE,
    payload: {
        displayServiceLine: value
    }
})

export const setDisplayOrganization = (value) => ({
    type: HOME_DISPLAY_ORGANIZATION,
    payload: {
        displayOrganization: value
    }
})

export const setDisplayOrbit = (value) => ({
    type: HOME_DISPLAY_ORBIT,
    payload: {
        displayOrbit: value
    }
})

export const setDiagnosticId = (value) => {
    return ({
        type: HOME_DIAGNOSTIC_ID,
        payload: {
            diagnosticId: value
        }
    })
}

export const setDisplayDiagnostics = (value) => ({
    type: HOME_DISPLAY_DIAGNOSTICS,
    payload: {
        displayDiagnostics: value
    }
})

export const setOrbitList = (value) => ({
    type: HOME_ORBIT_LIST,
    payload: {
        orbitList: value
    }
})

export const setDiagnosticFilterList = (value) => ({
    type: HOME_DIAGNOSTIC_FILTER_LIST,
    payload: {
        diagnosticFilterList: value
    }
})

export const setDiagnosticList = (value) => ({
    type: HOME_DIAGNOSTIC_LIST,
    payload: {
        diagnosticList: value
    }
})

export const setNavigateToHomePage = (value) => ({
    type: NAVIGATE_TO_HOME_PAGE,
    payload: {
        navigateToHomePage: value
    }
})

export const setRefreshTileAttributeList = (value) => ({
    type: REFRESH_TILE_ATTRIBUTE_LIST,
    payload: {
        refreshTileAttributeList: value
    }
})

export const setHome = (value) => ({
    type: HOME,
    payload: {
        tileAttributes: value.tileAttributes,
        clusterType: value.clusterType,
        useFlexContainer: value.useFlexContainer,
        clusterCssArray: value.clusterCssArray
    }
})

export const setTermsConditionsCompleted = (value) => ({
    type: TERMS_CONDITIONS_COMPLETED,
    payload: {
        termsConditionsCompleted: value
    }
})

export const setWelcomeMessage = (value) => ({
    type: SET_WELCOME_MESSAGE,
    payload: {
        welcomeMessage: value
    }
})

export const setViewedWelcomeMessage = (value) => ({
    type: SET_VIEWED_WELCOME_MESSAGE,
    payload: {
        viewedWelcomeMessage: value
    }
})


